export const ARTICLE_LIMIT = 2;

export const TRIAL_SUBSCRIPTION_ARTICLE_LIMIT = 10;
